import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import InputGenerico from '../../components/inputGenerico/inputGenerico';
import { postEsqueceuSenha } from '../../services/apiUsuario';
import { ToastContainer, toast } from 'react-toastify';
import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';

export default function EsqueceuSenha() {
    const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
    const [email, setEmail] = useState<string>("");

    const handleEmail = (e: any) => {
        setEmail(e.target.value);
    }

    const resetarSenha = async (e: any) => {
        e.preventDefault();
        try {
            if (email) {
                await postEsqueceuSenha(email);
                toast.success("Email de recuperação de senha enviado com sucesso!")
            }
            else {
                toast.error("Digite um email para recuperar a senha")
            }
        } catch (error) {
            toast.error("Não foi possível validar as credenciais!")
        }
    }

    return (
        <>
            <section style={{ display: 'grid', justifyContent: 'center'}}>
                <div className=" mt-5">
                    <h1 className="text-center mt-3 " style={{fontSize: '25px'}}>Recuperar Senha</h1>
                </div>

                <div className="rounded bg-light shadow" style={{  maxWidth: '500px', display: 'flex', justifyContent: 'center', padding: '30px 30px' }}>
                    <form className="">
                        <InputGenerico
                            name="email"
                            value={email}
                            onChange={handleEmail}
                            placeholder="seu@email.com"
                            className={`${!(email.length > 2) && validacaoAtiva ? "input-invalid" : ""} input-with-padding`}
                            type="text"
                            temLabel={false}
                        />
                        <div className="containerBotoes mt-2">
                            <button className="botoesLogin btn btn-outline-primary btn-sm mt-3" type="submit" onClick={(e) => resetarSenha(e)}>Enviar</button>
                            <a className="botoesLogin btn btn-outline-warning btn-sm mt-3" href="/milshop/usuario/incluir" role="button">Cadastre-se</a>
                        </div>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </>
    );
}
